import { render, staticRenderFns } from "./TrainingEssay.vue?vue&type=template&id=13d95f9d&"
import script from "./TrainingEssay.vue?vue&type=script&lang=js&"
export * from "./TrainingEssay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports